import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DistrictAdministrationService } from "../services/districtadministration.service";
import { UpdateDistSecurityRequest } from "./UpdateDistSecurityRequest";

@Component({
	selector: "app-security-settings",
	templateUrl: "./security-settings.component.html",
	styleUrls: ["./security-settings.component.css"],
})
export class SecuritySettingsComponent implements OnInit {
	constructor(private districtadministrationService: DistrictAdministrationService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadSecurityPrefs();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////
	OneAccountPerStaffMember: any = false;
	UsernameMustMatchEmail: any = false;
	UsernameEmailMustHaveDomain: any = false;
	PasswordExpID: any = 0;
	PasswordReuseID: any = 0;
	MinLength: any = "3";
	ContainNumbers: any = false;
	ContainSpecialChars: any = false;
	ChangeAfterAdminReset: any = false;
	LockoutAttemptsID: any = 0;
	MFAEnabled: any = false;
	LockAccountAfterDays: number = 0;
	InactiveLogoutMinutes: number = 0;

	lstPasswordExp: any = [
		{
			ID: 0,
			Desc: "Never",
		},
		{
			ID: 30,
			Desc: "30 Days",
		},
		{
			ID: 60,
			Desc: "60 Days",
		},
		{
			ID: 90,
			Desc: "90 Days",
		},
		{
			ID: 120,
			Desc: "120 Days",
		},
		{
			ID: 180,
			Desc: "180 Days",
		},
	];

	lstPasswordReuse: any = [
		{
			ID: 0,
			Desc: "Never",
		},
		{
			ID: 2,
			Desc: "2",
		},
		{
			ID: 4,
			Desc: "4",
		},
		{
			ID: 6,
			Desc: "6",
		},
		{
			ID: 8,
			Desc: "8",
		},
		{
			ID: 10,
			Desc: "10",
		},
		{
			ID: 12,
			Desc: "12",
		},
	];

	lstLockoutAttempts: any = [
		{
			ID: 0,
			Desc: "Never",
		},
		{
			ID: 3,
			Desc: "3",
		},
		{
			ID: 4,
			Desc: "4",
		},
		{
			ID: 5,
			Desc: "5",
		},
	];

	ConfirmPasswordWhenChanging: boolean = true;

	Processing: boolean = false;

	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////
	loadSecurityPrefs() {
		this.Processing = true;

		var result = this.districtadministrationService.LoadDistrictSecurityPreferenceList();
		result.subscribe(
			(response) => {
				var prefs: any = response;

				for (var i = 0; i < prefs.length; i++) {
					var next = prefs[i];

					console.log(next);

					if (next.KeyName == "OneAccountPerStaffMember") {
						this.OneAccountPerStaffMember = Number(next.KeyValue) == 1 ? true : false;
					}

					if (next.KeyName == "UsernameMustMatchEmail") {
						this.UsernameMustMatchEmail = Number(next.KeyValue) == 1 ? true : false;
					}
					if (next.KeyName == "UsernameEmailMustHaveDomain") {
						this.UsernameEmailMustHaveDomain = Number(next.KeyValue) == 1 ? true : false;
					}

					if (next.KeyName == "PasswordExpiration") {
						this.PasswordExpID = -1;
						var int = Number(next.KeyValue);
						for (var z = 0; z < this.lstPasswordExp.length; z++) {
							var next = this.lstPasswordExp[z];

							if (next.ID == int) {
								this.PasswordExpID = next.ID;
							}
						}

						if (this.PasswordExpID == -1) {
							this.PasswordExpID = this.lstPasswordExp[0].ID;
						}
					} else if (next.KeyName == "PasswordReuse") {
						this.PasswordReuseID = -1;
						var int = Number(next.KeyValue);
						for (var z = 0; z < this.lstPasswordReuse.length; z++) {
							var next = this.lstPasswordReuse[z];

							if (next.ID == int) {
								this.PasswordReuseID = next.ID;
							}
						}

						if (this.PasswordReuseID == -1) {
							this.PasswordReuseID = this.lstPasswordReuse[0].ID;
						}
					} else if (next.KeyName == "PasswordLength") {
						this.MinLength = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordNumbers") {
						this.ContainNumbers = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordSpecialChars") {
						this.ContainSpecialChars = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordReset") {
						this.ChangeAfterAdminReset = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordLockoutAttempts") {
						this.LockoutAttemptsID = -1;
						var int = Number(next.KeyValue);
						for (var z = 0; z < this.lstLockoutAttempts.length; z++) {
							var next = this.lstLockoutAttempts[z];

							if (next.ID == int) {
								this.LockoutAttemptsID = next.ID;
							}
						}

						if (this.LockoutAttemptsID == -1) {
							this.LockoutAttemptsID = this.lstLockoutAttempts[0].ID;
						}
					} else if (next.KeyName == "MFAEnabled") {
						this.MFAEnabled = next.KeyValue == "1" ? true : false;
					} else if (next.KeyName == "LockAccountAfterDays") {
						this.LockAccountAfterDays = Number(next.KeyValue);
					} else if (next.KeyName == "ConfirmPasswordWhenChanging") {
						if (next.KeyValue == "0" || String(next.KeyValue).toLowerCase() == "false") {
							this.ConfirmPasswordWhenChanging = false;
						}
					} else if (next.KeyName == "InactiveLogoutMinutes") {
						this.InactiveLogoutMinutes = Number(next.KeyValue);
					}
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onUpdate() {
		this.Processing = true;

		let parms: UpdateDistSecurityRequest = {
			PasswordExpiration: this.PasswordExpID,
			PasswordReuse: this.PasswordReuseID,
			PasswordLength: this.MinLength,
			PasswordNumbers: this.ContainNumbers == true ? "1" : "0",
			PasswordSpecialChars: this.ContainSpecialChars == true ? "1" : "0",
			PasswordReset: this.ChangeAfterAdminReset == true ? "1" : "0",
			PasswordLockoutAttempts: this.LockoutAttemptsID,
			MFAEnabled: this.MFAEnabled == true ? 1 : 0,
			LockAccountAfterDays: this.LockAccountAfterDays,
			InactiveLogoutMinutes: this.InactiveLogoutMinutes,
			ConfirmPasswordWhenChanging: this.ConfirmPasswordWhenChanging == true ? 1 : 0,
			OneAccountPerStaffMember: this.OneAccountPerStaffMember == true ? 1 : 0,
			UsernameMustMatchEmail: this.UsernameMustMatchEmail == true ? 1 : 0,
			UsernameEmailMustHaveDomain: this.UsernameEmailMustHaveDomain == true ? 1 : 0,
		};

		var result = this.districtadministrationService.UpdateDistrictSecuritySettings(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "security",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "District Security Settings were updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "security",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update district security settings",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDisableMFA() {
		this.Processing = true;

		var result = this.districtadministrationService.MFAUpdateAllSchools(0);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "security",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"All Schools have their MFA turned off. Users will not have to enter an MFA code unless the district has it turned on or they turn it on for their account.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "security",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update MFA settings for all schools",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUserExpirePasswordAll() {
		this.confirmationService.confirm({
			key: "confirmsecurity",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "This will make everyone change their password the next time they log in. Do you want to continue?",
			header: "Success",
			icon: "fa",
			accept: () => {
				this.onFinishUserExpirePasswordAll();
			},
		});
	}

	onFinishUserExpirePasswordAll() {
		this.Processing = true;

		var result = this.districtadministrationService.UserExpirePasswordAll(-1);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "security",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "All users passwords have been expired successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "security",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not expire users passwords: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////

	////////////////////////////////////
	// Helpers
	////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	////////////////////////////////////
}
